/* global mixpanel */
import formatDate from 'mixpanel/formatDate'

export function reportsCategorySalesStart ({outletIds, startDate, endDate}) {
  mixpanel.track('Report Category Sales Start', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': formatDate(startDate),
    'Current Time Filter End': formatDate(endDate)
  })
}
export function reportsCategorySalesChangeFilter ({outletIds, startDate, endDate}) {
  mixpanel.track('Report Category Sales Change Filter', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': formatDate(startDate),
    'Current Time Filter End': formatDate(endDate)
  })
}

export function reportsCategorySalesExport ({outletIds, startDate, endDate}) {
  mixpanel.track('Report Category Sales Export', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': formatDate(startDate),
    'Current Time Filter End': formatDate(endDate)
  })
}

export function reportsCategorySalesFTUE () {
  mixpanel.track('Report Category Sales FTUE', {})
}



// WEBPACK FOOTER //
// ./app/mixpanel/reports/categorySales.js